import {
  Button,
  Dialog,
  DialogContent,
  Grid2,
  IconButton,
  Typography,
} from "@mui/material";
import { IconX } from "@tabler/icons-react";
import { Input } from "./Input";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import Loading from "./Loading";
import { adminsCreate } from "../services/admins";
import { formatPhone, phoneValidate, unMask } from "../helpers/format";

const AdminsRegister = ({
  open,
  onClose,
  refetch,
}: {
  open: boolean;
  onClose: () => void;
  refetch: () => void;
}) => {
  const { mutate, isPending } = useMutation({
    mutationFn: adminsCreate,
    onSuccess: () => {
      onClose();
      refetch();
      toast.success("Administrador cadastrado");
    },

    onError: (e: { response: { data: { message: string } } }) => {
      toast.error(String(e?.response?.data?.message) || "Erro!");
    },
  });

  const { values, handleSubmit, handleChange } = useFormik({
    initialValues: {
      name: "",
      phone: "",
    },
    onSubmit: (values) => {
      const requiredFields = [
        { field: values.name, label: "Nome" },
        { field: values.phone, label: "Telefone" },
      ];

      for (const item of requiredFields) {
        if (!item.field || item.field.trim() === "") {
          toast.error(`Preencha o campo "${item.label}"`);
          return;
        }
      }
      if (!phoneValidate(formatPhone(values.phone))) {
        toast.error("Telefone inválido");
        return;
      }
      mutate({ ...values, phone: unMask(values.phone) });
    },
  });

  return (
    <Dialog maxWidth="xs" open={open} onClose={() => onClose()}>
      <Loading loading={isPending} />
      <DialogContent sx={{ backgroundColor: "secondary.main" }}>
        <Grid2 container spacing={2} padding={1}>
          <Grid2 size={{ xs: 10, md: 11 }}>
            <Typography variant="h2" fontSize={26} fontWeight={600}>
              Cadastrar administrador
            </Typography>
          </Grid2>
          <Grid2 size={{ xs: 2, md: 1 }}>
            <IconButton onClick={() => onClose()}>
              <IconX style={styles.iconStyle} />
            </IconButton>
          </Grid2>
          <Grid2 size={12}>
            <Input
              id="name"
              name="name"
              label="Nome"
              placeholder="Digite o nome"
              type="text"
              fullWidth
              size="small"
              value={values.name}
              onChange={handleChange}
            />
          </Grid2>
          <Grid2 size={12}>
            <Input
              id="phone"
              name="phone"
              label="Telefone"
              placeholder="Digite o telefone"
              type="text"
              fullWidth
              size="small"
              value={formatPhone(values.phone)}
              onChange={handleChange}
            />
          </Grid2>
          <Grid2 size={12}>
            <Button
              fullWidth
              variant="contained"
              size="large"
              onClick={() => handleSubmit()}
            >
              Criar administrador
            </Button>
          </Grid2>
        </Grid2>
      </DialogContent>
    </Dialog>
  );
};

const styles = {
  stackStyle: {
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
    padding: 1,
    borderRadius: 2,
    backgroundColor: "secondary.dark",
  },
  iconStyle: {
    color: "primary.main",
  },
};

export default AdminsRegister;
